const routes = [
    {
        path: "/infirmary",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'infirmaryuser_index'
        }
    }
];

export default routes;
